import { Asset, AssetPutRequest } from "callable-data-objects";
import { useAccount } from "Hooks/Endpoints";
import { APIAccountAssetContext } from "Providers/APIContexts";
import React, { useEffect, useState } from "react";
import { APIAccountProps, DefaultProviderProps } from "./types";

const APIAssetProvider = ({ children }: DefaultProviderProps) => {
  const {
    account,
    select: selectAccount,
    assetService,
  }: APIAccountProps = useAccount();
  const [assets, setAssets] = useState<Asset[]>([]);
  const [asset, setAsset] = useState<Asset | undefined>();
  const [createAsset, setCreateAsset] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function unload() {
    setTimeout(() => {
      setLoading(false);
    }, 250);
  }
  async function list() {
    setLoading(true);
    const resp = await assetService?.list();
    if (resp) {
      console.log("assets", assets);
      setAssets(resp);
    }
    unload();
  }

  async function select(id: string) {
    setLoading(true);
    const resp = await assetService?.get(id);
    if (resp) setAsset(resp);
    unload();
  }

  function unselect() {
    setAsset(undefined);
  }

  async function update(payload: AssetPutRequest) {
    if (asset && account) {
      setLoading(true);
      await assetService?.put(asset.id, payload);
      await list();
      await selectAccount(account.id);
      unselect();
      unload();
    }
  }

  async function save(payload: FormData) {
    if (account) {
      setLoading(true);
      const resp = await assetService?.postFormData("", payload);
      if (resp) {
        uncreate();
        list();
        selectAccount(account.id);
        unload();
      }
      setLoading(false);
    }
  }

  async function remove() {
    if (account && asset) {
      setLoading(true);
      await assetService?.delete(asset.id);
      selectAccount(account.id);
      list();
      unselect();
      unload();
    }
  }

  function create() {
    setCreateAsset({
      name: "",
      description: "",
    });
  }

  function uncreate() {
    setCreateAsset(undefined);
  }

  return (
    <APIAccountAssetContext.Provider
      value={{
        loading,
        account,
        assets,
        asset,
        createAsset,
        select,
        unselect,
        update,
        save,
        create,
        uncreate,
        remove,
      }}
    >
      {children}
    </APIAccountAssetContext.Provider>
  );
};

export default APIAssetProvider;
